
    // Submit Admission filter
function handleFormSubmit(e) {
    e.preventDefault();
    console.log('form submitted');

    var errorMessage = document.querySelector('.js-error-info');
    $(errorMessage).empty();


    var monthDropdown = document.getElementById("birth-month-dropdown");
    var month = monthDropdown.options[monthDropdown.selectedIndex].value;
    if (month == -1) {
      month = '';
      // monthDropdown.className = 'error';
    }  else {
      // monthDropdown.classList.remove('error');
    }

    var yearDropdown = document.getElementById("birth-year-dropdown");
    var year = yearDropdown.options[yearDropdown.selectedIndex].value;
    if (year == -1) {
      year = '';
      // yearDropdown.className = 'error';
    } else {
      // yearDropdown.classList.remove('error');
    }

    var locationDropdown = document.getElementById("location-dropdown");
    var location = locationDropdown.options[locationDropdown.selectedIndex].value;
    if (location == -1) {
      location = 'domestic';
    }

    var post_id = document.getElementById("admission-process").getAttribute('rel');

    var html = 'Please select both a month and year of birth';
    errorMessage.insertAdjacentHTML('beforeend', html);


    loadAdmissionsProcess(month, year, location, post_id);
}

  
function setSelectValuesFromURLAttributes(month, year, location) {
  var monthDropdown = document.getElementById("birth-month-dropdown");
  var yearDropdown = document.getElementById("birth-year-dropdown");
  var locationDropdown = document.getElementById("location-dropdown");
  monthDropdown.value=month;
  yearDropdown.value=year;
  locationDropdown.value=location;
}
  
  
function loadAdmissionURLAttributes() {
  // Get url attributes
  const queryString = window.location.search;
  console.log(queryString);
  // Only run functions if query string is not empty
  if ( queryString ) {
    const urlParams = new URLSearchParams(queryString);
    // If is site search, exit
    if ( urlParams.get('s') ) {
      return;
    }
    // Split attributes by - into array
    const admissionParams = urlParams.get('filter');
    if(admissionParams){
        var admissionParamsArray = admissionParams.split("-");
        // assign array items
        const admissionParamsMonth = admissionParamsArray[0];
        const admissionParamsYear = admissionParamsArray[1];
        const admissionParamsLocationShort = admissionParamsArray[2];
        if ( admissionParamsLocationShort == "int" ) {
          var admissionParamsLocation = "international";
        } else {
          var admissionParamsLocation = "domestic";
        }
        // get post id
        const post_id = document.getElementById("admission-process").getAttribute('rel');
        // Load ajax
        setSelectValuesFromURLAttributes(admissionParamsMonth, admissionParamsYear, admissionParamsLocation);
        loadAdmissionsProcess(admissionParamsMonth, admissionParamsYear, admissionParamsLocation, post_id);
    }
  }
}

  
  
  
// Trigger AJAX function
function loadAdmissionsProcess(month, year, location, post_id) {
  console.log('ajax triggered');
  if (month && year && location) {
    // Clear error message from form
    var errorMessage = document.querySelector('.js-error-info');
    $(errorMessage).empty();
    $.ajax({
      type: 'POST',
      url: php_vars.ajaxUrl,
      dataType: 'html',
      data: {
        action: 'calculate_admissions_process',
        mode: 'POST',
        month: month,
        year: year,
        location: location,
        post_id: post_id,
      },
      success: function success(html) {
        var destination = document.querySelector('.js-admissions-process');
        $(destination).empty();
        destination.insertAdjacentHTML('beforeend', html);
        // Create email link for Share button
        var mailtoLink = document.getElementById('js-share-admissions-link');
        var mailtoAttributes = month + '-';
        mailtoAttributes += year + '-';
        if ( location == "domestic" || location == 'dom' ) {
          mailtoAttributes += 'dom';
        } else {
          mailtoAttributes += 'int';
        }
        var mailtoLinkText = "mailto:?subject=Bishop's Stortford College Admissions Process&body=Check out Bishop's Stortford College's Admissions process at %0D%0Ahttp://bsc.dev.twkmedia.com/admissions/how-to-apply/?filter=" + mailtoAttributes;
        // mailtoLink.href=mailtoLinkText;
        // Scroll to tab-wrapper
        $('html, body').animate({
          scrollTop: $('.results').offset().top
        }, 750);
        // Initialise content slider
        // initialiseStepsSlider();
        // initialiseTimelineSlider();
        //scrollTimelineSlider();
        //initialiseTimelineSlider();
        admissionsTabs();
        stepTabs();
      },
      
      error: function(xhr, status, error) {
        console.log(error)
      }
    });
  }
}
  
function initialiseStepsSlider() {
  $('.steps-slider').slick({
    dots: false,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 4500,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    //asNavFor: '.timeline-slider',
  });
  $('.timeline__item').click(function(e) {
    e.preventDefault();
    $(this).parent().find('.timeline__item').removeClass('active');
    var id = $(this).data('index');
    $('.steps-slider').slick('slickGoTo', parseInt(id));
    $(this).addClass('active');
  });
}
  
function initialiseTimelineSlider() {
  $('.timeline-slider').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    freeScroll: true,
    groupCells: '80%',
    pageDots: false,
    prevNextButtons: true,
  });
  $('.timeline-slider').flickity('resize');

}
  
function admissionsTabs() {
  $('.tabs__controls li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.tabs__controls li').removeClass('active');
    $('.tabs__controls li').removeClass('after:h-1');
    $('.tabs__controls li').addClass('after:h-[1px]');
    $('.tabs__content').removeClass('active');
    $('.tabs__content').removeClass('block');
    $('.tabs__content').addClass('hidden');

    $(this).addClass('active');
    $(this).addClass('after:h-1');
    $(this).removeClass('after:h-[1px]');
    $("#"+tab_id).addClass('active');
    $("#"+tab_id).addClass('block');
    $("#"+tab_id).removeClass('hidden');

    $(window).trigger('resize');
    // $('.steps-slider').slick('refresh');
    //$('.timeline-slider').slick('refresh');
    // initialiseTimelineSlider();
  });
}
  
function stepTabs() {
    $('.steps-tabs__controls li').click(function(){
        var tab_id = $(this).attr('data-step-tab');
    
        $(this).closest('.steps-tabs').find('.steps-tabs__controls li').removeClass('active');
        $(this).closest('.steps-tabs').find('.steps-tabs__controls li').removeClass('after:w-full');
        $(this).closest('.steps-tabs').find('.steps-tabs__controls li').addClass('after:w-0');
        $(this).closest('.steps-tabs').find('.steps-tabs__content').removeClass('active');
        $(this).closest('.steps-tabs').find('.steps-tabs__content').removeClass('block');
        $(this).closest('.steps-tabs').find('.steps-tabs__content').addClass('hidden');
    
        $(this).addClass('active');
        $(this).removeClass('after:w-0');
        $(this).addClass('after:w-full');
        $(this).closest('.steps-tabs').find(("#"+tab_id)).addClass('active');
        $(this).closest('.steps-tabs').find(("#"+tab_id)).addClass('block');
        $(this).closest('.steps-tabs').find(("#"+tab_id)).removeClass('hidden');
    
        $(window).trigger('resize');
        // $('.steps-slider').slick('refresh');
        //$('.timeline-slider').slick('refresh');
        // initialiseTimelineSlider();
      });
}

function admissionsWidget() {

    if (document.querySelector('.js-admission-form-submit')) {
        document.querySelector('.js-admission-form-submit').addEventListener('click', handleFormSubmit, false);
    }
  
    loadAdmissionURLAttributes();
}

export default admissionsWidget;